import GuestOperationsSeatAllocation from './seatAllocation/guestOperations';

export default {
    namespaced: true,
    modules: {
        guestOperations: GuestOperationsSeatAllocation,
    },
};
